<template>
  <div>
    <v-card flat>
      <v-card-text>
        <v-autocomplete
          v-model="year_id"
          v-bind:label="$t('officer_config.academic_year')"
          v-bind:items="listFilter(config_years, level_id, 'LEVEL_ID')"
          v-bind:item-value="(item) => item.YEAR_ID"
          v-bind:item-text="(item) => item.SEMESTER + ' / ' + item.YEAR"
          outlined
          @change="(year_id) => select_year(year_id)"
        ></v-autocomplete>

        <div v-show="year_id && year_id">
          <v-btn
            color="success"
            @click="
              $refs.addEditCopyDialog.open_add_modal({
                rounds: rounds,
                years: config_years,
                level_id: level_id,
                year_id: year_id,
                round_id: round_id,
              })
            "
            class="mb-5 mt-4"
          >
            <v-icon>mdi-plus</v-icon>{{ $t("officer_config.addnew") }}
          </v-btn>

          <v-autocomplete
            v-model="round_id"
            v-bind:label="$t('officer_config.round_number_name')"
            v-bind:items="rounds_for_show(rounds)"
            v-bind:item-value="(item) => item.ROUND_ID"
            v-bind:item-text="
              (item) =>
                item.ROUND_NUMBER + ' - ' + objectTranslator(item, 'NAME')
            "
            outlined
            @change="(round_id) => select_round(round_id)"
          ></v-autocomplete>

          <div v-show="round_id && round_id">
            <v-divider class="mt-5 mb-5"></v-divider>
            <v-simple-table min-height="300px">
              <thead class="blue-grey darken-1">
                <tr>
                  <th class="white--text text-center" width="100px">
                    {{ $t("officer_config.edit") }}
                  </th>
                  <th class="white--text text-center" width="100px">
                    {{ $t("officer_config.copy") }}
                  </th>
                  <th class="white--text text-center" width="100px">
                    {{ $t("officer_config.delete") }}
                  </th>
                  <th class="white--text">#</th>
                  <!-- <th class="white--text">
                    {{ $t("officer_config.round_number_name") }}
                  </th> -->
                  <!-- <th class="white--text">
                    {{ $t("officer_config.project_code") }}
                  </th> -->
                  <th class="white--text">
                    {{ $t("officer_config.project_name_th") }}
                  </th>
                  <th class="white--text">
                    {{ $t("officer_config.project_name_en") }}
                  </th>
                  <th class="white--text">
                    {{ $t("officer_config.number_of_ranks") }}
                  </th>
                  <th class="white--text">
                    {{ $t("officer_config.application_fee") }}
                  </th>
                  <th class="white--text">
                    {{ $t("officer_config.start_application_date") }}
                    <br />
                    {{ $t("officer_config.end_application_date") }}
                  </th>
                  <th class="white--text">
                    {{ $t("officer_config.start_application_pay_date") }}
                    <br />
                    {{ $t("officer_config.end_application_pay_date") }}
                  </th>
                  <th class="white--text">
                    {{ $t("officer_config.start_confirm_date") }}
                    <br />
                    {{ $t("officer_config.end_confirm_date") }}
                  </th>
                  <th class="white--text">
                    {{ $t("officer_config.start_confirm_pay_date") }}
                    <br />
                    {{ $t("officer_config.end_confirm_pay_date") }}
                  </th>
                  <th class="white--text">
                    {{ $t("officer_config.applicant_can_upload_file") }}
                  </th>
                  <th class="white--text">
                    {{ $t("officer_config.enabled") }}
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="project in listFilter(projects, round_id, 'ROUND_ID')"
                  :key="project.PROJECT_ID"
                >
                  <td>
                    <v-btn
                      small
                      color="warning"
                      @click="
                        $refs.addEditCopyDialog.open_edit_modal({
                          item: project,
                          rounds: rounds,
                        })
                      "
                    >
                      <v-icon>mdi-pencil</v-icon>{{ $t("officer_config.edit") }}
                    </v-btn>
                  </td>
                  <td>
                    <v-btn
                      small
                      color="primary"
                      @click="
                        $refs.addEditCopyDialog.open_copy_modal({
                          item: project,
                          rounds: rounds,
                          level_id: level_id,
                          years: config_years,
                        })
                      "
                    >
                      <v-icon>mdi-content-copy</v-icon
                      >{{ $t("officer_config.copy") }}
                    </v-btn>
                  </td>
                  <td>
                    <v-btn
                      small
                      color="error"
                      @click="open_delete_modal(project)"
                    >
                      <v-icon>mdi-delete</v-icon
                      >{{ $t("officer_config.delete") }}
                    </v-btn>
                  </td>
                  <td>{{ project.PROJECT_ID }}</td>
                  <!-- <td>
                    {{
                            project.ROUND_NUMBER +
                              " - " +
                              objectTranslator(project, "ROUND_NAME")
                          }}
                  </td> -->
                  <!-- <td>{{ project.PROJECT_CODE }}</td> -->
                  <td>{{ project.PROJECT_NAME_TH }}</td>
                  <td>{{ project.PROJECT_NAME_EN }}</td>
                  <td>{{ project.NUMBER_OF_RANKS }}</td>
                  <td>{{ project.APPLICATION_FEE }}</td>
                  <td>
                    <div class="deep-orange--text nowrap">
                      {{ dt(project.START_APPLICATION_DATE) }}
                    </div>
                    <div class="brown--text nowrap">
                      {{ dt(project.END_APPLICATION_DATE) }}
                    </div>
                  </td>
                  <td>
                    <div class="deep-orange--text nowrap">
                      {{ dt(project.START_APPLICATION_PAY_DATE) }}
                    </div>
                    <div class="brown--text nowrap">
                      {{ dt(project.END_APPLICATION_PAY_DATE) }}
                    </div>
                  </td>
                  <td>
                    <div class="deep-orange--text nowrap">
                      {{ dt(project.START_CONFIRM_DATE) }}
                    </div>
                    <div class="brown--text nowrap">
                      {{ dt(project.END_CONFIRM_DATE) }}
                    </div>
                  </td>
                  <td>
                    <div class="deep-orange--text nowrap">
                      {{ dt(project.START_CONFIRM_PAY_DATE) }}
                    </div>
                    <div class="brown--text nowrap">
                      {{ dt(project.END_CONFIRM_PAY_DATE) }}
                    </div>
                  </td>
                  <td>
                    <div
                      class="deep-orange--text"
                      v-if="project.APPLICANT_CAN_UPLOAD_DOCUMENT === '1'"
                    >
                      <v-icon class="green--text">mdi-check</v-icon>
                    </div>
                    <div v-if="project.APPLICANT_CAN_UPLOAD_DOCUMENT === '0'">
                      <v-icon class="red--text">mdi-close</v-icon>
                    </div>
                  </td>
                  <td>
                    <div
                      class="deep-orange--text"
                      v-if="project.ENABLED === '1'"
                    >
                      <v-icon class="green--text">mdi-check</v-icon>
                    </div>
                    <div v-if="project.ENABLED === '0'">
                      <v-icon class="red--text">mdi-close</v-icon>
                    </div>
                  </td>
                </tr>
              </tbody>
            </v-simple-table>
          </div>
        </div>
      </v-card-text>
    </v-card>

    <ConfigProjectAddEditCopyDialog
      ref="addEditCopyDialog"
      :toggle_loading="toggle_loading"
      :fetch_data="fetch_data"
    />

    <ConfigDeleteDialog
      v-model="showing_delete_modal"
      :title="$t('officer_config.config_project')"
      :text="
        to_delete_project_item
          ? ' ' + objectTranslator(to_delete_project_item, 'PROJECT_NAME')
          : ''
      "
      :deleteFunction="delete_config_project"
    />
  </div>
</template>

<script>
import { listFilter } from "@/helper/filter";
import ConfigProjectAddEditCopyDialog from "@/components/config/ConfigProjectAddEditCopyDialog";
import ConfigDeleteDialog from "@/components/config/ConfigDeleteDialog";
import {
  objectTranslator,
  dateFromDBTranslator as dt,
} from "@/helper/translator";
import ConfigProvider from "@/services/config.provider";

const configService = new ConfigProvider();

export default {
  name: "ConfigProjectDisplay",
  data: function() {
    return {
      level_tab: null,
      showing_delete_modal: false,
      to_delete_project_id: null,
      to_delete_year_id: null,
      to_delete_project_item: null,

      rounds: [],
      projects: [],
      year_id: null,
      round_id: null,
    };
  },
  props: {
    level_id: {
      type: String,
    },
    toggle_loading: {
      type: Function,
    },
    config_years: {
      type: Array,
    },
  },
  components: {
    ConfigProjectAddEditCopyDialog,
    ConfigDeleteDialog,
  },
  methods: {
    dt,
    objectTranslator,
    listFilter,
    rounds_for_show(rounds_in_level) {
      if (rounds_in_level) {
        return [
          ...rounds_in_level,
          {
            NAME_EN: "All",
            NAME_TH: "ทั้งหมด",
            ROUND_ID: "all",
            ROUND_NUMBER: "",
          },
        ];
      } else return [];
    },

    async fetch_ref_data(year_id) {
      // non editable data of this page
      this.toggle_loading(true);
      const rounds = await configService.getFilteredRounds({ year_id });
      this.rounds = rounds;
      this.toggle_loading(false);
    },
    async fetch_data(year_id) {
      // editable data of this page
      this.toggle_loading(true);
      const projects = await configService.getFilteredProjects({ year_id });
      this.projects = projects;
      this.toggle_loading(false);
    },

    async select_year(year_id) {
      this.round_id = null;
      await this.fetch_ref_data(year_id);
      await this.fetch_data(year_id);
    },

    async select_round(round_id) {
      this.round_id = round_id;
      await this.fetch_data(this.year_id);
    },

    open_delete_modal(item) {
      this.to_delete_year_id = item.YEAR_ID;
      this.to_delete_project_id = item.PROJECT_ID;
      this.to_delete_project_item = item;
      this.showing_delete_modal = true;
    },
    async delete_config_project() {
      this.toggle_loading(true);

      let response = await configService
        .deleteProjects({
          id: this.to_delete_project_id,
        })
        .catch((error) => {
          this.$toasted.error(JSON.stringify(error.response.data.message), {
            duration: 0,
          });
          this.toggle_loading(false);
        });

      this.fetch_data(this.to_delete_year_id);

      if (response && response.status)
        this.$toasted.success(this.$t("toasted.delete_successfully"));
      else this.$toasted.error(this.$t("toasted.cannot_delete"));

      this.showing_delete_modal = false;
      this.toggle_loading(false);
    },
  },
};
</script>

<style>
.nowrap {
  white-space: nowrap;
}
</style>
